/* eslint-disable no-eval */

import lodashGet from 'lodash/get';
import logger from '~/utils/logger';

const OBJECT_SYMBOL = '[object Object]';
const STRING_SYMBOL = '[object String]';
const BOOLEAN_SYMBOL = '[object Boolean]';
const UNDEFINED_SYMBOL = '[object Undefined]';
const NUMBER_SYMBOL = '[object Number]';
const REGEXP_SYMBOL = '[object RegExp]';
const NULL_SYMBOL = '[object Null]';
const DATE_SYMBOL = '[object Date]';
const FUNCTION_SYMBOL = '[object Function]';
const ARRAY_SYMBOL = '[object Array]';

export function getObjType(target: any) {
  const string = Object.prototype.toString.call(target);
  switch (string) {
    case OBJECT_SYMBOL:
      return 'object';
    case STRING_SYMBOL:
      return 'string';
    case BOOLEAN_SYMBOL:
      return 'boolean';
    case NUMBER_SYMBOL:
      return 'number';
    case REGEXP_SYMBOL:
      return 'regexp';
    case NULL_SYMBOL:
      return 'null';
    case DATE_SYMBOL:
      return 'date';
    case FUNCTION_SYMBOL:
      return 'function';
    case ARRAY_SYMBOL:
      return 'array';
    case UNDEFINED_SYMBOL:
    default:
      return 'undefined';
  }
}

export function setObj(obj: any, path: string, value: any) {
  const properties = path.split('.');
  let parentProperty: any = obj;
  for (let i = 0; i < properties.length; i++) {
    let propertyName = properties[i];
    const isLastIndex = i === properties.length - 1;
    let arrayIndex = -1;
    let isArray = false;
    const matchResult = /\[(\d{1,})\]$/.exec(propertyName);
    if (matchResult) {
      propertyName = propertyName.substr(0, matchResult.index);
      arrayIndex = parseInt(matchResult[1], 0);
      isArray = true;
    }
    let nextProp = parentProperty[propertyName];
    const nextPropType = getObjType(nextProp);
    if (!isLastIndex) {
      if (nextPropType === 'object' || nextPropType === 'array') {
        // 下一个属性是object或者array的话，可以继续走
        // eslint-disable-next-line max-depth
        if (isArray && !nextProp[arrayIndex]) {
          // parent[p][index] === undefined 如果数组的那个没有，也需要动态创建一个对象
          nextProp[arrayIndex] = {};
        }
        parentProperty = !isArray ? nextProp : nextProp[arrayIndex];
      } else if (nextPropType === 'undefined' || nextPropType === 'null') {
        // eslint-disable-next-line max-depth
        if (isArray) {
          // 自动创建array或object
          nextProp = [];
          nextProp[arrayIndex] = {};
        } else {
          // 自动创建array或object
          nextProp = {};
        }
        parentProperty[propertyName] = nextProp;
        parentProperty = !isArray ? nextProp : nextProp[arrayIndex];
      }
    } else if (isArray) {
      // obj.xxxx[1]  = xxx
      // obj.xxxx is undefined
      if (!parentProperty[propertyName]) {
        parentProperty[propertyName] = [];
      }
      parentProperty[propertyName][arrayIndex] = value;
    } else {
      parentProperty[propertyName] = value;
    }
  }
}

export function omit(obj: any, path: string) {
  try {
    eval(`delete obj.${path}`);
  } catch (err) {
    logger.error(err, `plugin report delete obj.${path} error`);
  }
}
export function getObj(obj: any, path: string, defaultValue: any = '') {
  return lodashGet(obj, path, defaultValue);
}

export function isEmpty(value: any) {
  const type = getObjType(value);
  // 判断是否为空
  if (type === 'undefined' || type === 'null') {
    // 一切null，undefined忽略掉
    return true;
  }
  if (type === 'string') {
    if (!value.trim()) {
      // trim后是空串也算空
      return true;
    }
  }
  if (type === 'array') {
    return value.length === 0;
  }
  if (type === 'object') {
    return Object.getOwnPropertyNames(value).length === 0;
  }
  return false;
}
